/* Brunelia Riviera, lot 2 : fiche produit (formats, échelle, voir chez moi, galerie, quantité, barre collante,
   livraison offerte), page panier (code promo, rafraîchissement), page packs (filtre « nombre » de la page).
   S'appuie sur window.RV (rv-core.js). Tout fonctionne sans script : ce fichier ne fait qu'améliorer. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return window.RV && RV.money ? RV.money(c) : (Number(c) / 100).toFixed(2); };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Fiche produit ---------- */
  var root = $("[data-rv-pdp]");
  if (root) pdp(root);

  function pdp(root) {
    var form = $("form[data-rv-atc]", root);
    var free = window.RV && RV.freeConv ? RV.freeConv : root.getAttribute("data-free") === "0" ? 0 : Number(root.getAttribute("data-free")) || 5900; /* 0: threshold unknown in the visitor's currency (rv-ship-zone), the static line stays */
    var qin = $("[data-rv-qin]", root), qout = $("[data-rv-qout]", root);
    var gal = $("[data-rv-gal]", root);
    var galView = "wall", chezC = "#e3d2b0", chezHinted = false;
    var cartTotal = 0;
    var ADVICE = {
      A4: RV.t("lot2_js.advice_a4"),
      A3: RV.t("lot2_js.advice_a3"),
      A2: RV.t("lot2_js.advice_a2"),
      A1: RV.t("lot2_js.advice_a1"),
      A0: RV.t("lot2_js.advice_a0")
    };

    /* 24/10 (approf-cro.md §3/#8) : date de réception concrète (jours ouvrés réels de rv-ship-zone, borne haute
       dmax pour rester prudent). Calculée côté client, jamais côté serveur (une page produit mise en cache un jour
       afficherait une date fausse le lendemain). */
    (function () {
      var el = $("[data-rv-ship-date]", root);
      var dmax = el && Number(el.getAttribute("data-dmax")) || 0;
      if (!el || !dmax) return;
      var d = new Date(), added = 0;
      while (added < dmax) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      var fmt = "";
      try { fmt = new Intl.DateTimeFormat(window.RV && RV.lang, { day: "numeric", month: "long" }).format(d); } catch (e) {}
      if (fmt) { el.textContent = RV.t("lot2_js.ship_date", { date: fmt }); el.hidden = false; }
    })();

    function cur() { return form ? $("input[name=id]:checked", form) : null; }
    function qty() { return Math.max(1, Number(qin && qin.value) || 1); }

    function setFormat(r, fromUser) {
      if (!r) return;
      if (r.type !== "radio") { ship(); return; }
      var f = r.getAttribute("data-fmt"), price = Number(r.getAttribute("data-price")), cmp = Number(r.getAttribute("data-compare"));
      var p = $("[data-rv-p]", root); if (p) p.textContent = money(price);
      var c = $("[data-rv-c]", root);
      if (c) { if (cmp > price) { c.textContent = money(cmp); c.hidden = false; } else { c.hidden = true; } }
      var pf = $("[data-rv-pf]", root); if (pf) pf.textContent = RV.t("lot2_js.format_label", { f: f });
      var sp = $("[data-rv-sticky-p]"); if (sp) sp.textContent = money(price);
      $$("[data-rv-sv]").forEach(function (b) { b.setAttribute("aria-checked", String(b.getAttribute("data-rv-sv") === r.value)); });
      var avail = r.getAttribute("data-avail") !== "false";
      $$("[data-rv-buy]", root).concat($$("[data-rv-sticky] .btn-main")).forEach(function (b) {
        b.disabled = !avail;
        if (b.hasAttribute("data-rv-buy")) b.textContent = avail ? RV.t("lot2_js.buy") : RV.t("lot2_js.soon");
      });
      form.setAttribute("data-fmt", f);
      $$("[data-rv-heart]", root).forEach(function (h) { h.setAttribute("data-rv-format", f); });
      var url = root.getAttribute("data-url") + "?variant=" + r.value;
      $$("[data-rv-share]", root).forEach(function (b) { b.setAttribute("data-url", url); });
      $$("[data-rv-sendto]", root).forEach(function (b) { b.setAttribute("data-url", url); if (RV.sendRefresh) RV.sendRefresh(b); });
      var mail = $("[data-rv-mail]", root);
      if (mail) {
        var body = root.getAttribute("data-title") + "\n" + RV.t("lot2_js.mail_format", { f: f, dims: r.getAttribute("data-dims") ? " (" + r.getAttribute("data-dims") + ")" : "", price: money(price) }) + "\n" + url;
        mail.href = "mailto:?subject=" + encodeURIComponent(RV.t("lot2_js.mail_subject", { title: root.getAttribute("data-title") })) + "&body=" + encodeURIComponent(body);
      }
      if (fromUser && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set("variant", r.value); u.searchParams.delete("format"); u.searchParams.delete("taille"); history.replaceState(null, "", u.toString()); } catch (e) {}
      }
      drawScale(r); ship(); printLine(r);
      if (galView === "chez") renderChez();
    }

    /* 20/10: « Printed in Denmark » only when Gelato prints the chosen size there (snippet rv-print-country, data-ex), else the fallback line */
    function printLine(r) {
      var li = $("[data-rv-print]", root); if (!li || !r) return;
      var k = r.getAttribute("data-k") || "", off = !!k && (li.getAttribute("data-ex") || "").split(",").indexOf(k) > -1;
      var t = $("[data-rv-print-t]", li), x = $("[data-rv-print-x]", li);
      if (t) t.textContent = li.getAttribute(off ? "data-fb" : "data-lt");
      if (x) x.textContent = li.getAttribute(off ? "data-fbx" : "data-ltx");
    }

    function drawScale(r) {
      var box = $("[data-rv-scale]", root), txt = $("[data-rv-scale-txt]", root);
      if (!box || !txt || !r) return;
      var k = r.getAttribute("data-k"), d = r.getAttribute("data-dims");
      if (!d && !ADVICE[k]) { box.hidden = true; return; }
      box.hidden = false;
      txt.innerHTML = "<b>" + esc(r.getAttribute("data-fmt")) + (d ? " · " + esc(d) : "") + "</b>" + (ADVICE[k] ? " : " + ADVICE[k] : "");
    }

    /* Audit 18/10: the real cart and the projection « with this poster » are told apart (the cart already holding this
       poster used to be counted twice and showed « Livraison offerte » for a single A3). */
    /* 19/10 (Romain: « the sizes move down then up » on a format change): the message changes with the format
       (2 lines while delivery is not free, 1 line once it is), so the bar and everything under it used to change height.
       Every possible message (one per format, for the current cart) is measured once and the text box keeps the tallest
       height: a format change now only swaps words, never the height. Re-measured when the cart or the width changes. */
    function shipMsg(unit) {
      var proj = cartTotal + unit * qty(), leftNow = free - cartTotal, leftProj = free - proj;
      if (leftNow <= 0) return { html: RV.t("lot2_js.ship_free_already", { amount: (window.RV && RV.moneyShort ? RV.moneyShort(free) : money(free)) }), free: true, shown: cartTotal };
      if (cartTotal <= 0) return { html: leftProj > 0 ? RV.t("lot2_js.ship_left_proj", { left: money(leftProj), amount: (window.RV && RV.moneyShort ? RV.moneyShort(free) : money(free)) }) : RV.t("lot2_js.ship_free_proj"), free: leftProj <= 0, shown: proj };
      return { html: RV.t("lot2_js.ship_left_now", { left: money(leftNow) }) +
        '<small class="rv-ship-now">' + (leftProj > 0 ? RV.t("lot2_js.ship_more_left", { left: money(leftProj) }) : RV.t("lot2_js.ship_more_free")) + "</small>", free: false, shown: cartTotal };
    }
    var shipKey = "";
    function shipLock(bar, txt) {
      var key = cartTotal + "|" + qty() + "|" + bar.clientWidth;
      if (key === shipKey || !bar.clientWidth) return;
      shipKey = key;
      var units = form ? $$("input[name=id]", form).map(function (i) { return Number(i.getAttribute("data-price")) || 0; }) : [];
      var keepH = txt.innerHTML, keepF = bar.classList.contains("is-free"), max = 0;
      txt.style.minHeight = "";
      units.forEach(function (u) { var m = shipMsg(u); txt.innerHTML = m.html; bar.classList.toggle("is-free", m.free); max = Math.max(max, txt.getBoundingClientRect().height); });
      txt.innerHTML = keepH; bar.classList.toggle("is-free", keepF);
      txt.style.minHeight = max ? Math.ceil(max) + "px" : "";
    }
    function ship() {
      var bar = $("[data-rv-ship]", root); if (!bar || !free) return;
      var txt = $("[data-rv-ship-txt]", bar);
      var r = cur() || (form && $("input[name=id]", form)), unit = r ? Number(r.getAttribute("data-price")) || 0 : 0;
      var m = shipMsg(unit);
      shipLock(bar, txt);
      if (txt.innerHTML !== m.html) txt.innerHTML = m.html;
      bar.classList.toggle("is-free", m.free);
      /* 20/10 (Romain): two colours, solid = what is already in the cart, hatched = what this poster adds, so the
         visitor sees how far this poster takes him. Once the cart is already free, a single full bar. */
      var bi = $("i", bar), pr = $(".rv-ship-proj", bi);
      if (!pr) { pr = document.createElement("b"); pr.className = "rv-ship-proj"; pr.setAttribute("aria-hidden", "true"); bi.appendChild(pr); }
      var proj = cartTotal + unit * qty();
      bi.style.setProperty("--p", Math.min(100, Math.round((cartTotal >= free ? free : cartTotal) / free * 100)) + "%");
      bi.style.setProperty("--q", (cartTotal >= free ? 0 : Math.min(100, Math.round(proj / free * 100))) + "%");
      bar.classList.toggle("is-proj-free", cartTotal < free && proj >= free);
    }
    window.addEventListener("resize", function () { var b = $("[data-rv-ship]", root); if (b && b.clientWidth + "" !== shipKey.split("|")[2]) ship(); });
    function loadCart() {
      fetch((window.RV && RV.cartUrl || "/cart") + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; ship(); }).catch(function () {});
    }

    /* galerie : mur coloré, voir chez moi, photos */
    var frameHTML = gal ? gal.innerHTML : "";
    var sofaT = $("template[data-rv-sofa]", root);
    var wallAr = (gal && gal.getAttribute("data-wall-ar")) || "3/4", wallLand = wallAr === "4/3";
    var imgAr = (gal && gal.getAttribute("data-img-ar")) || wallAr;
    function renderWall() { gal.className = "gal-main pinhost is-poster" + (wallLand ? " is-land" : ""); gal.style.background = "transparent"; gal.style.setProperty("--ar", imgAr); gal.innerHTML = frameHTML; }
    /* « Voir chez moi » : scène à l'échelle réelle. Le meuble suit le format (commode pour A4 et A3,
       canapé de 200 cm au-delà), le cadrage s'adapte au meuble, l'affiche est accrochée 20 cm au-dessus. */
    var BUFFET = function (w) { return '<svg viewBox="0 0 ' + w + ' 82" preserveAspectRatio="none"><rect x="0" y="0" width="' + w + '" height="6" fill="#7a4a2b"/><rect x="3" y="6" width="' + (w - 6) + '" height="68" fill="#a8693e"/>' + (function () { var n = w > 120 ? 3 : 2, cw = (w - 16 - (n - 1) * 4) / n, o = ""; for (var i = 0; i < n; i++) { var x = 8 + i * (cw + 4); o += '<rect x="' + x + '" y="12" width="' + cw + '" height="16" fill="#b97a4b"/><rect x="' + x + '" y="32" width="' + cw + '" height="36" fill="#b97a4b"/><circle cx="' + (x + cw / 2) + '" cy="20" r="1.6" fill="#f3d38a"/><circle cx="' + (x + cw / 2) + '" cy="50" r="1.6" fill="#f3d38a"/>'; } return o; })() + '<rect x="6" y="74" width="5" height="8" fill="#7a4a2b"/><rect x="' + (w - 11) + '" y="74" width="5" height="8" fill="#7a4a2b"/></svg>'; };
    function renderChez() {
      var r = cur(); if (!gal) return;
      var w = r ? Number(r.getAttribute("data-w")) : 29.7, h = r ? Number(r.getAttribute("data-h")) : 0;
      if (!w) w = 29.7;
      gal.className = "gal-main pinhost chez"; gal.style.background = chezC;
      if (!chezHinted) { chezHinted = true; var hn = $("[data-rv-chez-hint]", root); if (hn) { try { if (localStorage.getItem("rv-chez-hint")) hn.hidden = true; else localStorage.setItem("rv-chez-hint", "1"); } catch (e) {} } } gal.style.setProperty("--ar", "3/4"); gal.innerHTML = frameHTML;
      var pm = $(".pm", gal); if (pm) pm.remove();
      var fr = $("[data-rv-gal-frame]", gal), img = fr && $("img", fr);
      var ratio = h ? h / w : (img && img.naturalWidth ? img.naturalHeight / img.naturalWidth : 1.414);
      /* toujours le même meuble (choix de Romain) : une commode de 100 cm, pour comparer les formats entre eux */
      var fw = 100, fh = 82, gap = 22, label = "une commode de 100 cm";
      var W = gal.clientWidth || 600, H = gal.clientHeight || W;
      var floor = Math.max(46, H * 0.09);
      var pHcm = w * ratio;
      /* cadrage serré : le meuble et l'affiche remplissent la scène, sans vide inutile */
      var px = Math.min(W * 0.86 / Math.max(fw, w) / 1.08, (H - floor - 36) / (fh + gap + pHcm * 1.1 + 6));
      var fW = fw * px, fH = fh * px, pW = w * px, pBottom = floor + fH + gap * px;
      if (fr) { fr.style.cssText = "position:absolute;left:50%;transform:translateX(-50%);bottom:" + pBottom + "px;width:" + pW + "px;padding:" + Math.max(2, Math.round(pW * 0.04)) + "px;margin:0;box-sizing:border-box;min-width:0;max-width:none"; $$("img,picture", fr).forEach(function (e) { e.style.width = "100%"; e.style.minWidth = "0"; e.style.maxWidth = "100%"; e.style.height = "auto"; }); }
      gal.insertAdjacentHTML("beforeend",
        '<div class="room-floor" style="position:absolute;left:0;right:0;bottom:0;height:' + floor + 'px;background:rgba(120,80,40,.18);border-top:2px solid rgba(0,0,0,.08)"></div>' +
        '<div class="room-furn" aria-hidden="true" style="position:absolute;left:50%;transform:translateX(-50%);bottom:' + floor + 'px;width:' + fW + 'px;height:' + fH + 'px">' + BUFFET(fw).replace('<svg', '<svg width="100%" height="100%"') + '</div>' +
        /* objets du quotidien à l'échelle, pour se rendre compte : vase de 20 cm et livres (toujours), lampe de 45 cm si l'affiche laisse la place */
        (function () {
          var top = floor + fH, left = (W - fW) / 2, o = "";
          var vx = left + fW - 26 * px, vw = 14 * px, vh = 20 * px;
          o += '<svg aria-hidden="true" style="position:absolute;left:' + vx + 'px;bottom:' + top + 'px;width:' + vw + 'px;height:' + vh + 'px" viewBox="0 0 14 20" preserveAspectRatio="none"><path d="M4 0h6v3c3 2 4 5 4 9 0 5-3 8-7 8S0 17 0 12c0-4 1-7 4-9z" fill="#2f6b4f"/></svg>';
          o += '<div aria-hidden="true" style="position:absolute;left:' + (vx - 26 * px) + 'px;bottom:' + top + 'px;width:' + (22 * px) + 'px;height:' + (6 * px) + 'px;background:linear-gradient(#1f6f9e 0 33%,#e86a50 33% 66%,#f2c230 66%)"></div>';
          if (w <= 30) {
            var lx = left + 6 * px, lw = 30 * px, lh = 45 * px;
            o += '<svg aria-hidden="true" style="position:absolute;left:' + lx + 'px;bottom:' + top + 'px;width:' + lw + 'px;height:' + lh + 'px" viewBox="0 0 30 45" preserveAspectRatio="none"><path d="M5 0h20l5 16H0z" fill="#f3e3c3" stroke="rgba(0,0,0,.15)"/><rect x="13.5" y="16" width="3" height="21" fill="#7a4a2b"/><ellipse cx="15" cy="41" rx="8" ry="4" fill="#7a4a2b"/></svg>';
          }
          return o;
        })() +
        '<p class="room-cap rv-chez-tag">' + (r ? (r.getAttribute("data-k") || r.getAttribute("data-fmt")) : "") + ' · ' + RV.t("lot2_js.chez_cap", { w: String(w).replace(".", RV.t("core_js.dec")), h: String(h ? h : Math.round(w * ratio * 10) / 10).replace(".", RV.t("core_js.dec")) }) + '</p>');
    }
    window.addEventListener("resize", function () { if (galView === "chez") renderChez(); });
    var PH_SIZES = "(min-width: 900px) 460px, 92vw";
    function renderPhoto(b) {
      gal.className = "gal-main pinhost is-photo"; gal.style.background = "";
      var ar = Number(b.getAttribute("data-ar")) || 0.75; gal.style.setProperty("--ar", String(ar));
      var pin = $(".pinbtn", gal), pinHTML = "";
      if (pin) { var a = pin.cloneNode(true); try { var u = new URL(a.href); u.searchParams.set("media", "https:" + b.getAttribute("data-pin").replace(/^https?:/, "")); a.href = u.toString(); } catch (e) {} pinHTML = a.outerHTML; }
      var th = $("img", b), thSrc = th ? (th.currentSrc || th.src) : "";
      /* aperçu flou instantané (la vignette agrandie), puis la grande image par-dessus dès qu'elle est prête */
      gal.innerHTML = pinHTML + (thSrc ? '<img class="photo ph-blur" src="' + esc(thSrc) + '" alt="" aria-hidden="true">' : "") +
        '<img class="photo ph-full" src="' + esc(b.getAttribute("data-src")) + '" srcset="' + esc(b.getAttribute("data-srcset")) + '" sizes="' + PH_SIZES + '" alt="' + esc(b.getAttribute("data-alt")) + '" decoding="async">';
      var full = $(".ph-full", gal);
      var done = function () { full.classList.add("is-in"); };
      if (full.complete && full.naturalWidth) done(); else full.addEventListener("load", done);
    }
    /* préchargement des mises en situation pendant que le navigateur est libre, à la taille utile */
    (function () {
      var btns = $$('.gal-thumbs button[data-view="photo"]', root); if (!btns.length) return;
      var pre = function (b) {
        if (b.__rvPre) return; b.__rvPre = 1;
        var im = new Image(); im.decoding = "async"; im.sizes = PH_SIZES; im.srcset = b.getAttribute("data-srcset"); im.src = b.getAttribute("data-src");
      };
      /* 18/10 speed: on phones and slow or data-saving connections, a photo is fetched only when its thumb is touched or hovered
         (the 3 photos weigh ~350 KB); on a desktop with a fast connection all are still prefetched when the browser is idle */
      btns.forEach(function (b) { ["pointerenter", "touchstart", "focus"].forEach(function (ev) { b.addEventListener(ev, function () { pre(b); }, { passive: true }); }); });
      var c = navigator.connection || {};
      if (c.saveData || /2g|3g/.test(c.effectiveType || "") || !window.matchMedia("(min-width: 900px)").matches) return;
      var run = function () { btns.forEach(pre); };
      var later = function () { if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 1200); };
      if (document.readyState === "complete") later(); else window.addEventListener("load", later);
    })();
    $$(".gal-thumbs button", root).forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".gal-thumbs button", root).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        galView = b.getAttribute("data-view");
        if (galView === "chez") renderChez(); else if (galView === "photo") renderPhoto(b); else renderWall();
      });
    });
    $$("[data-chez]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        chezC = b.getAttribute("data-chez");
        $$("[data-chez]", root).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        galView = "chez";
        $$(".gal-thumbs button", root).forEach(function (x) { x.setAttribute("aria-pressed", String(x.getAttribute("data-view") === "chez")); });
        renderChez();
      });
    });

    /* « Voir chez moi » depuis la colonne d'achat : bascule la galerie sur la scène et la montre */
    $$("[data-rv-chez-go]", root).forEach(function (b) {
      b.addEventListener("click", function (e) {
        var t = $('.gal-thumbs button[data-view="chez"]', root); if (t) t.click();
        if (gal) { var top = gal.getBoundingClientRect().top; if (top < 80 || top > innerHeight * 0.5) gal.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "center" }); }
        /* OS-3 : mesure sans cookie d'un clic humain confirmé (isTrusted) sur « Voir chez moi » */
        if (e.isTrusted && window.RV && RV.rechercheUrl && navigator.sendBeacon) {
          var mesure = new Blob([JSON.stringify({ type: "clic", action: "voir_chez_moi", page: location.pathname })], { type: "text/plain" });
          navigator.sendBeacon(RV.rechercheUrl, mesure);
        }
      });
    });

    /* formats et quantité */
    if (form) {
      form.addEventListener("change", function (e) { if (e.target.name === "id") setFormat(e.target, true); });
      /* audit achat-toutes-langues 23/10 constat 5 : bouton d'achat accéléré (Shop Pay/PayPal), formulaire séparé,
         son seul champ "id" est tenu à jour quand le format choisi change dans le formulaire principal. */
      var pb = $("[data-rv-pb-id]");
      if (pb) {
        form.addEventListener("change", function (e) {
          if (e.target && e.target.name === "id" && pb.value !== e.target.value) {
            pb.value = e.target.value;
            pb.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }
      $$("[data-rv-q]", form).forEach(function (b) {
        b.addEventListener("click", function () {
          var n = Math.min(20, Math.max(1, qty() + Number(b.getAttribute("data-rv-q"))));
          qin.value = n; if (qout) qout.textContent = n; ship();
        });
      });
      /* ?taille=A3 (?format= est réservé par Shopify : 404) dans l'adresse (liens partagés) : présélection du format */
      try {
        var _u = new URL(location.href), want = _u.searchParams.get("taille") || _u.searchParams.get("format");
        if (want) { var m = $$("input[name=id]", form).filter(function (i) { return (i.getAttribute("data-k") || "").toUpperCase() === want.toUpperCase(); })[0]; if (m) m.checked = true; }
      } catch (e) {}
      setFormat(cur() || $("input[name=id]", form), false);
    }

    /* barre d'achat collante : visible quand le bouton principal sort de l'écran */
    /* n'apparaît qu'une fois le bloc d'achat passé (au-dessus de l'écran), jamais avant */
    /* téléphone et tablette : la barre est toujours visible (le bouton de la page est masqué en CSS) ;
       ses pastilles de format n'apparaissent que quand le sélecteur de la page est hors de l'écran */
    /* v3.1 (Romain, 18/10) : ordinateur et téléphone, la barre n'apparaît que quand le bloc d'achat principal (formats + bouton)
       est hors de l'écran ; synchronisée dans les deux sens avec les formats (menu natif data-rv-satc-sel) */
    var sticky = $("[data-rv-sticky]"), mainBtn = $(".buy-row", root) || $("[data-rv-buy]", root);
    if (sticky && mainBtn && "IntersectionObserver" in window) {
      /* audit CRO 23/10 (approf-cro.md §3.1) : threshold:0 cachait la barre de secours dès qu'1 seul pixel du bouton
         principal rentrait dans l'écran (zone morte mesurée sur ~20 % d'un échantillon : 8 px visibles sur 58, ni le
         vrai bouton ni la barre cliquables). threshold:1 n'efface la barre que si le bouton est entièrement visible. */
      new IntersectionObserver(function (en) {
        var e = en[0]; sticky.hidden = e.isIntersecting;
        document.documentElement.classList.toggle("has-satc", !e.isIntersecting);
      }, { threshold: 1 }).observe(mainBtn);
    }
    var ssel = $("[data-rv-satc-sel]");
    if (ssel && form) {
      ssel.addEventListener("change", function () {
        var r = form.querySelector('input[name=id][value="' + ssel.value + '"]');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); }
      });
      form.addEventListener("change", function (e) { if (e.target && e.target.name === "id" && ssel.value !== e.target.value) ssel.value = e.target.value; });
      var c0 = cur(); if (c0) ssel.value = c0.value;
    }
    /* le premier format touché dans la scène fait disparaître l'indication */
    $$("[data-rv-chezctl] [data-rv-sv]", root).forEach(function (b) { b.addEventListener("click", function () { var hn = $("[data-rv-chez-hint]", root); if (hn) hn.hidden = true; }); });
    /* pastilles de format de la barre collante : même formulaire que le sélecteur principal */
    $$("[data-rv-sv]").forEach(function (b) {
      b.addEventListener("click", function () {
        var r = form && form.querySelector('input[name=id][value="' + b.getAttribute("data-rv-sv") + '"]');
        if (!r) return; r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
    document.addEventListener("rv:cart-change", loadCart);
    loadCart();
  }

  /* ---------- Page panier ---------- */
  var cp = $("[data-rv-cartpage]");
  if (cp) {
    document.addEventListener("rv:cart-change", function () { location.reload(); });
    var stk = $("[data-rv-cart-sticky]"), real = $("[data-rv-checkout]", cp);
    if (stk && real && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { stk.classList.toggle("is-off", en[0].isIntersecting); }).observe(real);
    }
    /* code promo : géré par rv-core.js (délégué sur tout le document, marche aussi dans le tiroir panier) */
    /* la note cadeau est enregistrée au fil de la frappe (elle part aussi avec « Commander ») */
    var note = $("#rv-cart-note", cp), t;
    if (note) note.addEventListener("input", function () {
      clearTimeout(t);
      t = setTimeout(function () {
        fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ note: note.value }) }).catch(function () {});
      }, 600);
    });
    $$(".rv-qin", cp).forEach(function (i) {
      i.addEventListener("change", function () { var f = $("#rv-cartform"); if (f) { var h = document.createElement("input"); h.type = "hidden"; h.name = "update"; h.value = "1"; f.appendChild(h); f.submit(); } });
    });
  }

  /* ---------- Page packs : filtre « nombre d'affiches » (page courante) ---------- */
  var pk = $("[data-rv-packs]");
  if (pk) {
    var on = null, grid = $("[data-pk-grid]", pk), zero = $("[data-pk-zero]", pk), out = $("[data-pk-n]", pk), base = out ? out.innerHTML : "";
    var apply2 = function () {
      var shown = 0;
      $$(".rv-pkw", grid).forEach(function (c) { var ok = !on || c.getAttribute("data-n") === on; c.hidden = !ok; if (ok) shown++; });
      $$("[data-pn]", pk).forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-pn") === on)); });
      if (zero) zero.hidden = shown > 0;
      if (out) out.innerHTML = on ? RV.t("lot2_js.packs_count", { packs: (window.RV && RV.plural ? RV.plural(shown, "pack") : shown + " packs"), n: on }) : base;
      if (on && grid) {
        var top = out.getBoundingClientRect().top;
        if (top < 0) out.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      }
    };
    pk.addEventListener("click", function (e) {
      var b = e.target.closest("[data-pn]"); if (b) { on = on === b.getAttribute("data-pn") ? null : b.getAttribute("data-pn"); apply2(); return; }
      if (e.target.closest("[data-pn-undo]")) { on = null; apply2(); }
    });
  }

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
})();

/* Zoom sur les photos produit (Romain, 07/10 et 08/10) : clic ou toucher sur l'image principale OU une vignette
   (hors « Chez moi », scène simulée, pas une vraie photo) -> plein écran en haute définition, avec navigation
   entre toutes les photos de la galerie (flèches, clavier, glisser au doigt). Fermeture : croix, Échap, clic à côté.
   Sur téléphone, le pincement reste natif (touch-action: pinch-zoom sur la fenêtre). Zoom au survol sur ordinateur
   sur l'affiche et les mises en situation. */
(function () {
  var gal = document.querySelector("[data-rv-gal]"); if (!gal) return;
  var thumbs = document.querySelector(".gal-thumbs");
  var box = document.createElement("div"); box.className = "rv-zoom"; box.hidden = true; box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true"); box.setAttribute("aria-label", RV.t("lot2_js.zoom_label"));
  box.innerHTML = '<button type="button" class="rv-zoom-x" aria-label="' + RV.t("lot2_js.zoom_close") + '">×</button>' +
    '<button type="button" class="rv-zoom-nav rv-zoom-prev" aria-label="' + RV.t("lot2_js.zoom_prev") + '">‹</button>' +
    '<button type="button" class="rv-zoom-nav rv-zoom-next" aria-label="' + RV.t("lot2_js.zoom_next") + '">›</button>' +
    '<div class="rv-zoom-stage"><img alt=""></div>' +
    '<p class="rv-zoom-tip">' + RV.t("lot2_js.zoom_tip") + '</p>' +
    '<p class="rv-zoom-count"></p>';
  document.body.appendChild(box);
  var stage = box.querySelector(".rv-zoom-stage"), im = box.querySelector("img"), tip = box.querySelector(".rv-zoom-tip"), count = box.querySelector(".rv-zoom-count");
  var prevBtn = box.querySelector(".rv-zoom-prev"), nextBtn = box.querySelector(".rv-zoom-next");
  var last = null, items = [], idx = 0;
  function hd(src) { if (!src) return ""; src = src.split(" ")[0]; return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, "$12400") : src + (src.indexOf("?") > -1 ? "&" : "?") + "width=2400"; }
  function current() {
    var i = gal.querySelector("[data-rv-gal-frame] img") || gal.querySelector("img:not(.rv-pin img)");
    if (gal.classList.contains("is-photo")) i = gal.querySelector("img") || i;
    return i;
  }
  /* la galerie à zoomer = l'affiche (vignette « wall ») + les mises en situation (« photo ») ; « Chez moi » est une scène simulée, pas une photo */
  function buildItems() {
    if (!thumbs) { var i = current(); return i ? [{ src: hd(i.currentSrc || i.src), alt: i.alt || "", btn: null }] : []; }
    var btns = Array.prototype.slice.call(thumbs.querySelectorAll("button"));
    return btns.filter(function (b) { return b.getAttribute("data-view") !== "chez"; }).map(function (b) {
      var im2 = b.querySelector("img");
      var src = b.getAttribute("data-src") || (im2 ? (im2.currentSrc || im2.src) : "");
      return { src: hd(src), alt: b.getAttribute("data-alt") || b.getAttribute("aria-label") || "", btn: b };
    });
  }
  function indexOfActive() {
    var active = thumbs && thumbs.querySelector('button[aria-pressed="true"]:not([data-view="chez"])');
    for (var i = 0; i < items.length; i++) { if (active && items[i].btn === active) return i; }
    return 0;
  }
  function show(i) {
    if (!items.length) return;
    idx = (i + items.length) % items.length;
    im.src = items[idx].src; im.alt = items[idx].alt;
    box.classList.remove("is-z");
    tip.textContent = RV.t("lot2_js.zoom_tip");
    count.textContent = items.length > 1 ? (idx + 1) + " / " + items.length : "";
    prevBtn.hidden = nextBtn.hidden = items.length < 2;
  }
  function open(i) {
    items = buildItems(); if (!items.length) return;
    last = document.activeElement;
    show(i == null ? indexOfActive() : i);
    box.hidden = false; document.documentElement.style.overflow = "hidden"; box.querySelector(".rv-zoom-x").focus();
  }
  function close() { box.hidden = true; box.classList.remove("is-z"); document.documentElement.style.overflow = ""; if (last && last.focus) last.focus(); }
  function next() { show(idx + 1); }
  function prevItem() { show(idx - 1); }
  var b = document.createElement("button"); b.type = "button"; b.className = "rv-zoom-btn"; b.setAttribute("aria-label", RV.t("lot2_js.zoom_btn"));
  b.innerHTML = '<svg width="18" height="18" aria-hidden="true"><use href="#i-search"/></svg>';
  gal.appendChild(b);
  b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); open(); });
  gal.addEventListener("click", function (e) { if (e.target.tagName === "IMG" && !gal.classList.contains("chez") && !e.target.closest(".rv-pin, a")) { e.preventDefault(); open(); } });
  /* Romain (08/10) : un clic sur une vignette change seulement la photo affichée, il n'ouvre PAS le zoom.
     Le zoom s'ouvre par la loupe ou par un clic sur la grande image. */
  im.addEventListener("click", function (e) {
    var z = box.classList.toggle("is-z"); tip.textContent = z ? RV.t("lot2_js.zoom_tip_back") : RV.t("lot2_js.zoom_tip");
    /* Romain (08/10) : zoom AU POINT CLIQUÉ (agrandissement sur place, origine = point cliqué), puis la souris déplace la zone agrandie */
    if (z) zoomAt(e.clientX, e.clientY); else { im.style.removeProperty("--ox"); im.style.removeProperty("--oy"); }
  });
  function zoomAt(x, y) {
    var r = im.getBoundingClientRect(); if (!r.width) return;
    var fx = Math.max(0, Math.min(1, (x - r.left) / r.width)), fy = Math.max(0, Math.min(1, (y - r.top) / r.height));
    im.style.setProperty("--ox", (fx * 100).toFixed(1) + "%"); im.style.setProperty("--oy", (fy * 100).toFixed(1) + "%");
  }
  /* la zone agrandie suit la souris ; on mesure sur l'image non transformée via son conteneur */
  stage.addEventListener("mousemove", function (e) {
    if (!box.classList.contains("is-z")) return;
    var r = stage.getBoundingClientRect(), w = im.offsetWidth, h = im.offsetHeight, l = r.left + (r.width - w) / 2, t = r.top + (r.height - h) / 2;
    im.style.setProperty("--ox", (Math.max(0, Math.min(1, (e.clientX - l) / w)) * 100).toFixed(1) + "%");
    im.style.setProperty("--oy", (Math.max(0, Math.min(1, (e.clientY - t) / h)) * 100).toFixed(1) + "%");
  });
  box.addEventListener("click", function (e) { if (e.target === box || e.target === stage) close(); });
  box.querySelector(".rv-zoom-x").addEventListener("click", close);
  prevBtn.addEventListener("click", function (e) { e.stopPropagation(); prevItem(); });
  nextBtn.addEventListener("click", function (e) { e.stopPropagation(); next(); });
  document.addEventListener("keydown", function (e) {
    if (box.hidden) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowRight") next();
    else if (e.key === "ArrowLeft") prevItem();
  });
  /* glisser au doigt pour changer de photo (pas pendant un zoom au clic, pour laisser parcourir l'image agrandie) */
  var tx = 0, ty = 0, tracking = false;
  stage.addEventListener("touchstart", function (e) { if (e.touches.length !== 1) return; tx = e.touches[0].clientX; ty = e.touches[0].clientY; tracking = true; }, { passive: true });
  stage.addEventListener("touchend", function (e) {
    if (!tracking) return; tracking = false;
    if (box.classList.contains("is-z") || items.length < 2) return;
    var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { if (dx < 0) next(); else prevItem(); }
  }, { passive: true });
  /* zoom au survol sur ordinateur (affiche et mises en situation, pas la scène « Chez moi ») */
  var canHover = window.matchMedia && matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (canHover) {
    var hoverImg = function () { return gal.classList.contains("chez") ? null : (gal.querySelector("[data-rv-gal-frame] img") || gal.querySelector(".ph-full")); };
    gal.addEventListener("mousemove", function (e) {
      var img = hoverImg(); if (!img) return;
      var r = img.getBoundingClientRect(), x = (e.clientX - r.left) / r.width * 100, y = (e.clientY - r.top) / r.height * 100;
      if (x < 0 || x > 100 || y < 0 || y > 100) return;
      img.style.transformOrigin = x + "% " + y + "%"; img.classList.add("rv-hoverzoom");
    });
    gal.addEventListener("mouseleave", function () { var img = hoverImg(); if (img) img.classList.remove("rv-hoverzoom"); });
  }
})();
